import { RendererType, Scene } from '@marketertechnologies/property-picker';
import { camelizeKeys } from 'humps';

import requestInstance from '~/utils/requestInstance';

export type GetPropertyExplorerScenesArgs = {
  projectUuid: string;
  sceneUuid?: string;
};

export type PropertyExplorerScenesResponse = {
  projectUuid: string;
  rendererType: RendererType;
  scenes: Scene[];
};

export const getPropertyExplorerScenes = async (args: GetPropertyExplorerScenesArgs) => {
  const { projectUuid, sceneUuid } = args;

  try {
    if (!projectUuid) {
      return Promise.reject(`Missing projectUuid, ${projectUuid}`);
    }

    const query = sceneUuid ? `?scene_uuid=${sceneUuid}` : '';

    const response = requestInstance.get(
      `/property_pickers/${projectUuid}/scenes_per_level${query}`,
    );

    return camelizeKeys((await response).data) as PropertyExplorerScenesResponse;
  } catch (e) {
    console.error(e);
  }
};
